import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/exams/interactive/:examId/publish`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const publish = {
  post: apiPathFunc(pathBase),
} as const;
